import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';

@Injectable()
export class OrderWithAiService {
  constructor(private apiService: ApiService) {}

  parsePrompt(data: any): Observable<any> {
    return this.apiService.post({
      url: 'order-with-ai/parse',
      body: data
    });
  }

  chatrooms(data: any): Observable<any> {
    return this.apiService.post({
      url: 'order-with-ai/chatrooms',
      body: data
    });
  }

  messages(data: any): Observable<any> {
    return this.apiService.post({
      url: 'order-with-ai/messages',
      body: data
    });
  }

  getAgents(data: any): Observable<any> {
    return this.apiService.post({
      url: 'product/getAgents',
      body: data
    });
  }

  getProductTimeSlots(data: any): Observable<any> {
    return this.apiService.post({
      url: 'get_product_timeslots',
      body: data
    });
  }

  checkTimeSlots(data: any): Observable<any> {
    return this.apiService.post({
      url: 'order/checkTimeSlots',
      body: data
    });
  }

  sendMessage(data: any): Observable<any> {
    return this.messages(Object.assign({}, data, { action: 'send' }));
  }

  appendMessages(data: any): Observable<any> {
    return this.messages(Object.assign({}, data, { action: 'append' }));
  }

  updateContext(data: any): Observable<any> {
    return this.messages(Object.assign({}, data, { action: 'update_context' }));
  }
}
